export const calendar = {
  title: 'Το Ημερολόγιό μου',
  subtitle: 'Διαχειριστείτε τη διαθεσιμότητά σας και συγχρονίστε τα ημερολόγιά σας',
  calendar: {
    today: 'Σήμερα',
    month: 'Μήνας',
    week: 'Εβδομάδα',
    day: 'Ημέρα',
    selectDates: 'Επιλέξτε ημερομηνίες',
    blockDates: 'Αποκλεισμός ημερομηνιών',
    unblockDates: 'Αποκατάσταση αυτών των ημερομηνιών',
    addNote: 'Προσθήκη σημείωσης',
    selectEvent: 'Επιλέξτε ένα γεγονός',
    nMonths: 'μήνες',
    oneMonth: '1 μήνας',
    months: { january: 'Ιανουάριος', february: 'Φεβρουάριος', march: 'Μάρτιος', april: 'Απρίλιος', may: 'Μάιος', june: 'Ιούνιος', july: 'Ιούλιος', august: 'Αύγουστος', september: 'Σεπτέμβριος', october: 'Οκτώβριος', november: 'Νοέμβριος', december: 'Δεκέμβριος' },
    days: { monday: 'Δευ', tuesday: 'Τρί', wednesday: 'Τετ', thursday: 'Πέμ', friday: 'Παρ', saturday: 'Σάβ', sunday: 'Κυρ' }
  },
  sync: { title: 'Συγχρονισμός iCal', description: 'Συνδέστε το ημερολόγιό σας Airbnb ή PMS για να συγχρονίσετε αυτόματα τη διαθεσιμότητά σας', addConnection: 'Προσθήκη σύνδεσης', noConnections: 'Χωρίς συνδέσεις', icalUrl: 'URL iCal', icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...', platform: 'Πλατφόρμα', platformPlaceholder: 'Π.χ.: Airbnb, Booking.com, PMS...', syncNow: 'Συγχρονισμός τώρα', lastSync: 'Τελευταίος συγχρονισμός', eventsImported: 'γεγονότα εισαγωγή', status: { synced: 'Συγχρονισμένο', pending: 'Εκκρεμεί', error: 'Σφάλμα', syncing: 'Συγχρονισμός...' }, remove: 'Αφαίρεση', edit: 'Επεξεργασία' },
  exchanges: { title: 'Επερχόμενα Ανταλλάγματα', noExchanges: 'Κανένα ανταλλάγμα δεν έχει προγραμματιστεί', viewProfile: 'Προβολή προφίλ', sendMessage: 'Αποστολή μηνύματος', confirm: 'Επιβεβαίωση', decline: 'Απόρριψη', cancel: 'Ακύρωση', guests: 'ταξιδιώτες', status: { confirmed: 'Επιβεβαιωμένο', pending: 'Εκκρεμεί', proposal: 'Πρόταση', blocked: 'Αποκλεισμένο' } },
  legend: { title: 'Θρύλος', available: 'Διαθέσιμο', confirmed: 'Επιβεβαιωμένο ανταλλάγμα', pending: 'Εκκρεμής αίτημα', proposal: 'Πρόταση', blocked: 'Αποκλεισμένες ημερομηνίες' },
  blockModal: { title: 'Αποκλεισμός ημερομηνιών', reason: 'Λόγος (προαιρετικό)', reasonPlaceholder: 'Π.χ.: Ανακαινίσεις, προσωπικές διακοπές...', from: 'Από', to: 'Προς', block: 'Αποκλεισμός', cancel: 'Ακύρωση' },
  notifications: { datesBlocked: 'Ημερομηνίες αποκλεισμένες με επιτυχία', datesUnblocked: 'Ημερομηνίες αποκατάστασης με επιτυχία', syncSuccess: 'Συγχρονισμός επιτυχής', syncError: 'Σφάλμα συγχρονισμού', connectionAdded: 'Σύνδεση προστέθηκε με επιτυχία', connectionRemoved: 'Σύνδεση αφαιρέθηκε', exchangeConfirmed: 'Ανταλλάγμα επιβεβαιωμένο', exchangeDeclined: 'Ανταλλάγμα απορρίφθηκε' },
  details: 'Λεπτομέρειες',
  upcomingExchanges: 'Επερχόμενα Ανταλλάγματα',
  noExchangesPlanned: 'Κανένα ανταλλάγμα δεν έχει προγραμματιστεί',
  daysSelected: 'ημέρες επιλεγμένες',
  daySelected: 'ημέρα επιλεγμένη',
  from: 'Από',
  to: 'Προς',
  reasonOptional: 'Λόγος (προαιρετικό)',
  reasonPlaceholder: 'Π.χ.: Ανακαινίσεις, προσωπικές διακοπές...',
  block: 'Αποκλεισμός',
  cancel: 'Ακύρωση',
  namePlaceholder: 'Όνομα (π.χ.: Airbnb)',
  filters: 'Φίλτρα',
  actions: 'Ενέργειες',
  connections: 'Συνδέσεις'
};

export default calendar;
